// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modules-slider-container {
    margin-bottom: 3rem;
    padding: 0 1rem;
    max-width: 1920px;
    width: 100%;
}

.mySwiper {
    width: 100%;
}

.module-card {
    background-color: #fff;
    border-radius: 12px;
    padding: 1rem;
    height: 200px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

@media (min-width: 768px) {
    .module-card {
        padding: 1.5rem;
        height: 250px;
        width: 100%;
    }
}

.module-icon {
    width: 24px;
    height: 24px;
    margin-bottom: 0.5rem;
}

@media (min-width: 768px) {
    .module-icon {
        width: 32px;
        height: 32px;
    }
}

.module-title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #2d2d2d;
}

.module-text {
    font-size: 0.875rem;
    color: #666;
}

.navigation-buttons {
    display: flex;
    justify-content: right;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1.5rem;
}

.nav-button img {
    width: 16px;
    height: auto;
}

@media (max-width: 767px) {
    .navigation-buttons {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/slider/ModulesSlider.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,wCAAwC;IACxC,UAAU;IACV,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI;QACI,eAAe;QACf,aAAa;QACb,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".modules-slider-container {\n    margin-bottom: 3rem;\n    padding: 0 1rem;\n    max-width: 1920px;\n    width: 100%;\n}\n\n.mySwiper {\n    width: 100%;\n}\n\n.module-card {\n    background-color: #fff;\n    border-radius: 12px;\n    padding: 1rem;\n    height: 200px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    width: 90%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n@media (min-width: 768px) {\n    .module-card {\n        padding: 1.5rem;\n        height: 250px;\n        width: 100%;\n    }\n}\n\n.module-icon {\n    width: 24px;\n    height: 24px;\n    margin-bottom: 0.5rem;\n}\n\n@media (min-width: 768px) {\n    .module-icon {\n        width: 32px;\n        height: 32px;\n    }\n}\n\n.module-title {\n    font-size: 1rem;\n    font-weight: bold;\n    margin-bottom: 0.5rem;\n    color: #2d2d2d;\n}\n\n.module-text {\n    font-size: 0.875rem;\n    color: #666;\n}\n\n.navigation-buttons {\n    display: flex;\n    justify-content: right;\n    gap: 1rem;\n    margin-top: 2rem;\n    padding-top: 1.5rem;\n}\n\n.nav-button img {\n    width: 16px;\n    height: auto;\n}\n\n@media (max-width: 767px) {\n    .navigation-buttons {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
